import store from '@/components/store/store'
import { getCookieValue } from '@/components/util/cookies'
import { reportApiFailure } from '@/services/monitoring'

export const apiClient = async (path, data = {}) => {
  const token = getCookieValue('token')
  try {
    const url = 'https://lk.lineon.me/api/' + path
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      },
      body: JSON.stringify(data)
    });

    if (response.status === 401) {
      await store.dispatch('auth/revokeUser');
      // Можно дополнительно выбросить ошибку или вернуть
      return;
    }

    const raw = await response.text()
    let parsed = null
    try {
      parsed = raw ? JSON.parse(raw) : {}
    } catch {
      parsed = null
    }

    if (response.status >= 500) {
      reportApiFailure({
        url,
        method: 'POST',
        statusCode: response.status,
        message: parsed?.error?.message || parsed?.error || `api_${response.status}`,
        requestId: response.headers.get('x-request-id') || '',
        responseBody: raw,
      })
    }

    return parsed ?? { success: false, error: { code: 'invalid_json_response' } }

  } catch (err) {
    reportApiFailure({
      url: 'https://lk.lineon.me/api/' + path,
      method: 'POST',
      statusCode: 0,
      message: err?.message || 'network_error',
    })
  }
}
